/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { createTheme } from '@mui/material/styles';
import {
  AIADMIN_BORDER_DEFAULT_COLOR,
  AIADMIN_FONT_FAMILY,
  AIADMIN_PRIMARY_COLOR,
  AIADMIN_PRIMARY_HOVER_COLOR,
  AIADMIN_SECONDARY_TEXT_COLOR,
  AIADMIN_SURFACE_HOVER_COLOR,
  AIADMIN_SURFACE_HOVER_LIGHT_COLOR,
  AIADMIN_SURFACE_WHITE_HEX_COLOR,
  AIADMIN_TEXT_PRIMARY,
  AIADMIN_TEXT_SECONDARY
} from '../../common/styles/aiadminThemeTokens';

// A light theme built from the dashboard tokens. The app theme itself is "dark" mode with white text on
// white paper, which made the panel unreadable.
const panelTheme = createTheme({
  typography: { fontFamily: AIADMIN_FONT_FAMILY },
  palette: {
    mode: 'light',
    primary: { main: AIADMIN_PRIMARY_COLOR, dark: AIADMIN_PRIMARY_HOVER_COLOR, contrastText: AIADMIN_TEXT_SECONDARY },
    text: { primary: AIADMIN_TEXT_PRIMARY, secondary: AIADMIN_SECONDARY_TEXT_COLOR },
    divider: AIADMIN_BORDER_DEFAULT_COLOR,
    background: { paper: AIADMIN_SURFACE_WHITE_HEX_COLOR, default: AIADMIN_SURFACE_HOVER_LIGHT_COLOR }
  },
  components: {
    MuiChip: {
      styleOverrides: {
        outlined: {
          borderColor: AIADMIN_BORDER_DEFAULT_COLOR,
          color: AIADMIN_TEXT_PRIMARY,
          '&:hover': { backgroundColor: AIADMIN_SURFACE_HOVER_COLOR }
        }
      }
    }
  }
});

export default panelTheme;
